export const MEDIA_BASE_URL: string =
  process.env.REACT_APP_MEDIA_URL || 'http://localhost/media/';

export function getMediaUrl(possibleFullUrl: string): string {
  let pathPart = possibleFullUrl;

  try {
    const urlObj = new URL(possibleFullUrl);
    pathPart = urlObj.pathname;
  } catch (err) {
    // Not a full URL, use as-is
  }

  // Remove any leading slashes and 'media/' prefix if already present
  pathPart = pathPart.replace(/^\/+/, '').replace(/^media\//, '');

  return `${MEDIA_BASE_URL.replace(/\/$/, '')}/${pathPart}`;
}
